import type { TableStyles } from "react-data-table-component";

/**
 * Shared react-data-table-component theme for all add-in data listings.
 * Mirrors `frontend/src/config/dataTableTheme.ts` (single source per app).
 */
export const dataTableCustomStyles: TableStyles = {
  table: {
    style: {
      borderRadius: "0.75rem",
      overflow: "hidden",
      border: "1px solid var(--color-divider, #e5e7eb)",
      boxShadow: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    },
  },
  headRow: {
    style: {
      backgroundColor: "var(--color-light-bg, #f8fafc)",
      borderBottomWidth: "1px",
      borderBottomColor: "var(--color-divider, #e2e8f0)",
      minHeight: "52px",
    },
  },
  headCells: {
    style: {
      fontSize: "14px",
      fontWeight: 700,
      textTransform: "none" as const,
      letterSpacing: "normal",
      color: "var(--color-heading, #1f2a44)",
      paddingLeft: "1.25rem",
      paddingRight: "1.25rem",
      paddingTop: "1rem",
      paddingBottom: "1rem",
    },
  },
  rows: {
    style: {
      minHeight: "56px",
      fontSize: "0.875rem",
      color: "var(--color-body, #2b3348)",
      backgroundColor: "#ffffff",
      fontWeight: 400,
      borderBottomStyle: "solid",
      borderBottomWidth: "1px",
      borderBottomColor: "var(--color-divider, #e2e8f0)",
      "&:hover": {
        backgroundColor: "var(--color-light-bg, #f8fafc)",
        cursor: "default",
      },
    },
    stripedStyle: {
      backgroundColor: "#ffffff",
    },
  },
  cells: {
    style: {
      paddingLeft: "1.25rem",
      paddingRight: "1.25rem",
      paddingTop: "0.875rem",
      paddingBottom: "0.875rem",
      fontWeight: 400,
      fontSize: "14px",
      color: "var(--color-body, #2b3348)",
      verticalAlign: "middle",
    },
  },
  pagination: {
    style: {
      borderTopWidth: "0",
      borderTopColor: "transparent",
      fontSize: "0.875rem",
      color: "var(--color-secondary, #6b7280)",
      minHeight: "0",
      padding: "0",
    },
    pageButtonsStyle: {
      borderRadius: "0.375rem",
      height: "32px",
      minWidth: "32px",
      padding: "4px 8px",
      cursor: "pointer",
      transition: "all 0.2s ease-in-out",
      color: "#374151",
      fill: "#374151",
      "&:disabled": {
        cursor: "not-allowed",
        color: "#d1d5db",
        fill: "#d1d5db",
      },
      "&:hover:not(:disabled)": {
        backgroundColor: "#f3f4f6",
      },
    },
  },
  noData: {
    style: {
      padding: "3rem",
      color: "var(--color-secondary, #6b7280)",
      fontSize: "0.875rem",
    },
  },
};
